import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';

Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/layout/index.vue'),
      children: [
        {
          path: '/main',
          name: 'IndexHome',
          component: Home
        }
      ]
    },
    {
      path: '/',
      name: 'home',
      component: Home
    }
  ]
});
